import { FormularioTrabajo } from '../components/FormularioTrabajo';

export default function CrearTrabajo() {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <FormularioTrabajo />
    </div>
  );
}